import { useReveal, Picture, Source, VideoLoop } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Grid$1 from '../Grid/Grid.js';
import Text$1 from '../../basics/Text/Text.js';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import StyledMainStage from './MainStage.style.js';

const MainStageWrapper = ({
  children,
  link
}) => link ? /*#__PURE__*/React$1.createElement(Link$1, _extends({}, link, {
  icon: undefined,
  noHover: true,
  className: "mainStage__link"
}), children) : children;

MainStageWrapper.propTypes = {
  children: PropTypes$1.node.isRequired,
  link: PropTypes$1.shape()
};
MainStageWrapper.defaultProps = {
  link: undefined
};

const MainStage = (_ref) => {
  let {
    headline,
    title,
    hideBreadcrumb,
    subline,
    excerpt,
    image,
    video,
    loop,
    link,
    breadcrumbLink
  } = _ref,
      props = _objectWithoutProperties(_ref, ["headline", "title", "hideBreadcrumb", "subline", "excerpt", "image", "video", "loop", "link", "breadcrumbLink"]);

  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledMainStage, _extends({
    hasMedia: Boolean(image || video),
    hasLink: Boolean(link)
  }, props), /*#__PURE__*/React$1.createElement(MainStageWrapper, {
    link: link
  }, /*#__PURE__*/React$1.createElement(Grid$1, {
    className: "mainStage__grid",
    ref: ref
  }, image || video ? /*#__PURE__*/React$1.createElement("div", {
    className: "mainStage__media"
  }, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible,
    direction: "left"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "mainStage__media-ratio"
  }, image && !video ? /*#__PURE__*/React$1.createElement(Picture, {
    src: image.url || image.src,
    srcset: image.srcset,
    alt: image.alt,
    lazy: true
  }, image.source && /*#__PURE__*/React$1.createElement(Source, {
    srcset: image.source,
    media: "(max-width: 768px)",
    lazy: true
  })) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: video.url,
    loop: loop,
    autoPlay: true
  }) : null))) : null, !hideBreadcrumb && /*#__PURE__*/React$1.createElement("div", {
    className: "mainStage__breadcrumb"
  }, breadcrumbLink && /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "mainStage__breadcrumbLink"
  }, breadcrumbLink), breadcrumbLink.label && breadcrumbLink.label)), /*#__PURE__*/React$1.createElement("div", {
    className: "mainStage__headline"
  }, /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    variant: "hero",
    as: "h1",
    reveal: true,
    isVisible: isVisible,
    text: headline
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "mainStage__subline"
  }, /*#__PURE__*/React$1.createElement(Typography$1, {
    variant: "subheadline",
    as: "h2",
    reveal: true,
    revealVariant: "secondary",
    isVisible: isVisible
  }, subline)), excerpt && /*#__PURE__*/React$1.createElement(Text$1, {
    content: excerpt,
    className: "mainStage__excerpt"
  }))));
};

MainStage.propTypes = {
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  excerpt: PropTypes$1.string,
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string,
    width: PropTypes$1.number,
    height: PropTypes$1.number,
    source: PropTypes$1.shape()
  }),
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  loop: PropTypes$1.bool,
  hideBreadcrumb: PropTypes$1.bool,
  breadcrumbLink: PropTypes$1.shape(),
  link: PropTypes$1.shape(),
  title: PropTypes$1.string.isRequired
};
MainStage.defaultProps = {
  subline: null,
  excerpt: null,
  image: null,
  video: null,
  loop: true,
  hideBreadcrumb: false,
  breadcrumbLink: null,
  link: null
};

export default MainStage;
